import { memoize } from "lodash";
import { utilBalancing } from "../utils/utilBalancing";
export var selectBalancingPVPMapDefinitions = memoize(function () { return utilBalancing.getBalancing().PVPMapDefinitions; });
export var selectBalancingPVPMapDefinition = memoize(function (id) {
    var definitions = selectBalancingPVPMapDefinitions();
    return definitions.get(id);
});
export var selectBalancingPVPMapMinUnitsProduction = memoize(function (id) {
    var infos = selectBalancingPVPMapDefinition(id);
    return infos && infos.pvpUnitProductionMinAmount ? infos.pvpUnitProductionMinAmount : 0;
});
export var selectBalancingPVPMapMaxUnitsProduction = memoize(function (id) {
    var infos = selectBalancingPVPMapDefinition(id);
    return infos && infos.pvpUnitProductionMaxAmount ? infos.pvpUnitProductionMaxAmount : 0;
});
export var balancingPVPMapDefinitionsMemoizedFunctions = [
    selectBalancingPVPMapDefinitions,
    selectBalancingPVPMapMinUnitsProduction,
    selectBalancingPVPMapMaxUnitsProduction,
];



//////////////////
// WEBPACK FOOTER
// ./src/balancingSelectors/selectBalancingPvPMapDefinitions.ts
// module id = 482
// module chunks = 3